import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import './style.scss'

class ProductsVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
    }
    this.firstFunction = this.firstFunction.bind(this)
  }

  firstFunction() {}

  componentDidMount() {
    var query = {
      order: 'asc',
      orderby: 'title',
      exclude: this.props.excludeProducts,
    }

    var qString = queryString.stringify(query)

    console.log('excludeProducts:' + this.props.excludeProducts) //eslint-disable-line
    console.log(this.props) //eslint-disable-line
    console.log(qString) //eslint-disable-line
    console.log('/wp-json/dhsv/v2/lek023/products?' + qString) //eslint-disable-line

    // Rest API Params
    fetch(`/wp-json/dhsv/v2/lek023/products?${qString}`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState({
          products: data,
        })
      })
      .catch(function (err) {
        console.log('Error: ', err) // eslint-disable-line
      })
  }

  render() {
    const { products } = this.state
    const { excludeProducts } = this.props

    console.log(products) //eslint-disable-line
    console.log(excludeProducts) //eslint-disable-line

    return (
      <div className="dhsv_vc_products">
        {products.length ? (
          <div className="dhsv_vc_products_container">
            {products.map((product, i) => (
              <a
                key={i}
                className="dhsv_vc_product_item"
                style={{ backgroundImage: `url(${product.image})` }}
                href={product.link}
              >
                <div className="dhsv_vc_product_item_info">
                  <div className="dhsv_vc_product_item_info_container">
                    <p>Go Fresh</p>
                    <h3>{product.title}</h3>
                  </div>
                  <div className="dhsv_vc_product_item_info_more">
                    Jetzt entdecken
                  </div>
                </div>
              </a>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

ProductsVC.propTypes = {
  excludeProducts: PropTypes.number,
}

export default ProductsVC
